import { COUNTRYANDSTATE_LOADING, GET_COUNTRYANDSTATE_DATA_SUCCESS, GET_COUNTRYANDSTATE_DATA_ERROR } from "../actions/actionCountryAndState";
import { put, takeEvery } from 'redux-saga/effects';
import { apiCountryAndState } from 'api';

async function fetchAsync(func, param) {
  const response = await func(param);

  if (response.ok && response.status == 200) {
    return await response.json();
  }
  else if (response.status == 204) {
    return "nocontent";
  }
  if (response.status == 400) {
    let error = await response.json();
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
  }
  else {
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get countries and states, response status: " + response.status + "\"}]}")
  }
}

function* fetchCountryAndState(action) {
  try {
    
    const data = yield fetchAsync(apiCountryAndState)
    yield put({ type: GET_COUNTRYANDSTATE_DATA_SUCCESS, payload: data });
    
  } catch (e) {
    yield put({ type: GET_COUNTRYANDSTATE_DATA_ERROR, error: e.Errors[0].ErrorMessage });
  }
}

export const sagaCountryAndState = [
  takeEvery(COUNTRYANDSTATE_LOADING, fetchCountryAndState)
];
